import { render, staticRenderFns } from "./marquees.vue?vue&type=template&id=24bb7700&scoped=true"
import script from "./marquees.vue?vue&type=script&lang=js"
export * from "./marquees.vue?vue&type=script&lang=js"
import style0 from "./marquees.vue?vue&type=style&index=0&id=24bb7700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb7700",
  null
  
)

export default component.exports